import { Illustration, Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function NoLicenseRequired() {
  return (
    <Stack
      sx={{
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 5,
        margin: "auto",
      }}
    >
      <Illustration type="success" />
      <Title variant="h6" component="h2">
        Approved to work shifts!
      </Title>

      <Text>This role does not require any specific certification.</Text>
    </Stack>
  );
}
